import { streakAchievement } from './helpers';

export default streakAchievement(30, 210);
